const styles = {
    root: `
    height: 100%;
    max-height: 100%;
    `,
};

export default styles;
